export default function HeroLogo() {
  return (
    <img
      src="/iksha-logo.png"
      alt="IKSHA — Art + Architecture"
      data-testid="hero-logo"
      className="w-full max-w-[720px] h-auto select-none mx-auto"
    />
  );
}
